import {MxSelector} from '../store.types';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ViewportState} from '@aviary/store/viewport/viewport.state';
import {VIEWPORT_FEATURE_KEY, ViewportSize} from '@aviary/store/viewport/viewport.types';

export namespace ViewportSelectors {
  export const entireState: MxSelector<ViewportState> = createFeatureSelector(VIEWPORT_FEATURE_KEY);

  /**
   * How to interpret the returned ViewportSize value:
   * - 'sm' means the current viewport width is less than 'md'.
   * - 'md' means the current viewport width is 'md' or greater, but less than 'lg'.
   * - 'lg' means the current viewport width is 'lg' or greater.
   */
  export const currentViewportSize: MxSelector<ViewportSize> = createSelector(
    entireState,
    ({viewportSize}) => viewportSize
  );

  export const isSm: MxSelector<boolean> = createSelector(
    currentViewportSize,
    size => size === 'sm'
  );

  export const isMdAndUp: MxSelector<boolean> = createSelector(
    currentViewportSize,
    size => size !== 'sm'
  );

  export const isLgAndUp: MxSelector<boolean> = createSelector(
    currentViewportSize,
    size => size === 'lg'
  );
} // namespace ViewportSelectors
